export const addProductToOrder = (productId: number, productAmount?: number) => ({
  type: "@saga/ADD_PRODUCT_TO_ORDER",
  payload: {productId, productAmount},
});
